module.exports = __webpack_public_path__ + "media/correct.46a685f2.mp3";